import {
  TableAdapter,
  TableAdapterHook,
} from 'src/components/DataTable/types/DataTable';
import { createSearchAdapter } from 'src/components/DataTable/adapters/useSearchAdapter';
import {
  EmployeeSearchResultItem,
  EmployeeSearchResultItemResponse,
} from 'src/types/Employee';
import { camelizeResponseData } from 'src/utilities/http-data-casing';

export function createEmployeeListAdapter(
  corpId: string
): TableAdapterHook<EmployeeSearchResultItem> {
  const useSearchAdapter =
    createSearchAdapter<EmployeeSearchResultItemResponse>({
      searchUrl: `/corps/${corpId}/diners/search`,
    });

  return function useEmployeeListAdapter(): TableAdapter<EmployeeSearchResultItem> {
    const adapter = useSearchAdapter();

    return {
      ...adapter,
      data: adapter.data.map((employeeResponse) =>
        camelizeResponseData<EmployeeSearchResultItemResponse>(employeeResponse)
      ),
    };
  };
}
